import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { AssetCardDesktop as Card } from '../asset-card/desktop';

import { AssetsCarousel as Component } from './component';
import type { IDepsDesktop, TAssetsCarouselDesktop } from './models';
import styles from './styles.css';
// eslint-disable-next-line styler/check-styler
export const AssetsCarouselDesktop = createWidget<IDepsDesktop, TAssetsCarouselDesktop>({
    Card,
    styles,
})(Component);
